import { FC, ReactNode, useState } from 'react';
import {
  CampaignMetadataContext,
  CampaignMetadataContextValue,
  getDefaultCMSMetadata,
} from './CampaignMetadataContext';
import {
  CMSMetadata,
  BusinessGroupId,
  PageId,
  PageType,
  Placement,
  Provider,
  Slot,
} from '@amzn/fire-tv-campaign-automation-service';

interface CampaignMetadataContextProviderProps {
  children: ReactNode;
}

export const CampaignMetadataContextProvider: FC<CampaignMetadataContextProviderProps> = ({
  children,
}) => {
  const [metadata, setMetadata] = useState<CMSMetadata>(getDefaultCMSMetadata());

  const updateMetadata = (updates: Partial<CMSMetadata>) => {
    setMetadata((prev: CMSMetadata) => ({
      ...prev,
      ...updates,
    }));
  };

  const contextValue: CampaignMetadataContextValue = {
    metadata,
    updateMetadata,
  };

  return (
    <CampaignMetadataContext.Provider value={contextValue}>
      {children}
    </CampaignMetadataContext.Provider>
  );
};
